import { Box } from "@mui/material";
import { FlowConsignadoVisualizarAbaClienteDTO } from "../consignado-visualizar-dialog.model";
import { Item } from "./Item";

export const AbaCliente = (props: { data: FlowConsignadoVisualizarAbaClienteDTO; }) => {
    return <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px'
        }}
    >
        <Item label="Nome / Razão social" value={props.data.nomeRazaoSocial} />
        <Item label="Nome Fantasia" value={props.data.nomeFantasia} />
        <Item label="Identificação" value={props.data.identificacao} />
        <Item label="Inscrição estadual" value={props.data.inscricaoEstadual} />
        <Item label="País" value={props.data.pais} />
        <Item label="Município" value={props.data.municipio} />
        <Item label="Endereço" value={props.data.endereco} />
        <Item label="Telefone" value={props.data.telefone} />
        <Item label="E-mail" value={props.data.email} />
    </Box>;
};
